export enum WebConferenceErrorCode {
    wrongTime = "webConference.slot.wrongTime",
    scheduleNotFound = "webConference.slot.scheduleNotFound",
    banned = "webConference.banned"
}